module.exports = __webpack_public_path__ + "img/tenvio_app.e77d2f82.svg";